'use strict';

export enum PopoverArrowLocation {
  Center = 'Center',
  End = 'End',
  Start = 'Start',
}
